import type { ConversionCategory } from '../../utils/detectFileCategory';
import type {
  UniversalConvertBundle,
  UniversalCodeSettings,
  UniversalDocumentSettings,
  UniversalEmailSettings,
  UniversalGlobalPdfSettings,
  UniversalHtmlSettings,
  UniversalImageSettings,
  UniversalPresentationSettings,
  UniversalSpreadsheetSettings,
} from '../../utils/convertUniversal';

const globalDefaults = (): UniversalGlobalPdfSettings => ({
  pageSize: 'auto',
  orientation: 'auto',
  quality: 'high',
});

export function createDefaultBundle(category: ConversionCategory): UniversalConvertBundle {
  const global = globalDefaults();

  switch (category) {
    case 'email':
      return {
        global,
        email: {
          includeBody: true,
          includeHeaders: true,
          includeAttachmentList: true,
          embedAttachmentIds: [],
        } satisfies UniversalEmailSettings,
        image: {
          fitMode: 'fitPage',
          centerImage: false,
          preserveExifOrientation: true,
          background: 'white',
        } satisfies UniversalImageSettings,
      };
    case 'document':
      return {
        global,
        document: {
          preserveFormatting: true,
          includeImages: true,
          keepLinks: true,
          margins: 'normal',
        } satisfies UniversalDocumentSettings,
      };
    case 'spreadsheet':
      return {
        global,
        spreadsheet: {
          sheetIndex: 0,
          fitPageWidth: true,
          gridlines: true,
          repeatHeader: true,
        } satisfies UniversalSpreadsheetSettings,
      };
    case 'presentation':
      return {
        global,
        presentation: {
          oneSlidePerPage: true,
          preserveAspectRatio: true,
          includeSpeakerNotes: false,
        } satisfies UniversalPresentationSettings,
      };
    case 'image':
      return {
        global,
        image: {
          fitMode: 'fitPage',
          centerImage: true,
          preserveExifOrientation: true,
          background: 'white',
        } satisfies UniversalImageSettings,
      };
    case 'html':
      return {
        global,
        html: {
          includeBackgroundGraphics: false,
          printFriendly: false,
          preserveLinks: true,
        } satisfies UniversalHtmlSettings,
      };
    case 'code':
      return {
        global,
        code: {
          syntaxHighlight: true,
          lineNumbers: true,
          wrapLongLines: true,
          theme: 'light',
        } satisfies UniversalCodeSettings,
      };
    case 'text':
      return {
        global,
        document: {
          preserveFormatting: true,
          includeImages: true,
          keepLinks: true,
          margins: 'normal',
        } satisfies UniversalDocumentSettings,
      };
    default:
      return { global };
  }
}
